import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubDraftsRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-drafts',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
	exact: true,
};
